import React, { forwardRef, Key, useEffect, useImperativeHandle, useState } from 'react';
import { Stack, Card, CardActionArea, Box, Alert, Button, Grid } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'src/app/react/hooks/redux';
import DataTable, { TableColumn } from 'react-data-table-component';
import { getCollaborators } from 'src/app/react/redux/collaborator/actions';
import { addCollaboratorsPurchase } from "src/app/react/redux/purchase/actions";
import { Auth } from 'src/app/models/auth';
import { CollaboratorRequest } from 'src/app/react/models/collaborator/collaborator-request.model';
import { CollaboratorResponse } from 'src/app/react/models/collaborator/collaborator-response.model';
import { CollaboratorProducts, CollaboratorsPurchaseRequest } from 'src/app/react/models/purchase/collaborators-purchase-request.model';
import { SvgCard } from '../../../shared/SvgCard/SvgCard';
import { Product } from 'src/app/react/models/product/product-response.model';
import { Table, Divider, Tag, Input } from 'antd';
import { useStateCallback } from 'src/app/react/hooks/useStateCallback';
import CollaboratorsFilterModal from '../Modals/CollaboratorsFilterModal';
import { MODAL_COLLABORATORS_PURCHASE_FILTER_HIDE, MODAL_COLLABORATORS_PURCHASE_FILTER_SHOW } from 'src/app/react/redux/contants';

interface CollaboratorsPurchaseProps {
    // onCollaboratorsPurchase: any;
    // handleHasError: (value: boolean) => void;
    purchaseType: number;
    purchaseOption: number;
    productsId?: number[]
}

interface CollaboratorsFilterProps {
    name?: string;
    document?: string;
    register?: string;
    costCenter?: string;
    departament?: string;
    unity?: string;
}

const { Column } = Table;

let offset = 0;
let currentPage = 1;
let limit = 10;

export const CollaboratorsPurchase = forwardRef(({ purchaseType, purchaseOption, productsId }: CollaboratorsPurchaseProps, ref) => {

    const currentUser: Auth = JSON.parse(localStorage.getItem('currentUser'));

    const dispatch = useAppDispatch();
    const { purchase } = useAppSelector(state => state.purchase);
    const { products } = useAppSelector(state => state.product);
    const { products: productsOfGroup, groupId } = useAppSelector(state => state.group);
    const { collaborators, error, loading } = useAppSelector(state => state.collaborator);
    const { showCollaboratorsPurchaseFilterModal } = useAppSelector(state => state.modal);

    const [ selectedProducts, setSelectedProducts ] = useState<Product[]>([]);
    const [ selectedProductIndex, setSelectedProductIndex ] = useState<number>(0);
    const [ selectedProduct, setSelectedProduct] = useState<number>(0);
    const [ updateSelectedCollaborators, setUpdateSelectedCollaborators ] = useStateCallback([]);

    const [ selectedCollaborators, setSelectedCollaborators ] = useState<any[]>([]);
    const filteredProducts = products?.filter(x=> purchaseType !== 1 ? productsId.includes(x.productId) : productsOfGroup.includes(x.productId));

    const [ errorMessage, setErrorMessage ] = useState<string>(null);

    const [ isFilterEnabled, setIsFilterEnabled] = useState<boolean>(false);

    useEffect(() => {

        currentPage = 1;

        const collaboratorsFilter = handleCollaboratorsFilter(true);

        handleGetCollaborators(collaboratorsFilter);

        setSelectedProduct(filteredProducts[0].productId);
        setSelectedProducts(filteredProducts);
    },[])

    useEffect(() => {
        //onCollaboratorsPurchase.current = handleCollaboratorsPurchase;
    }, [selectedProduct, selectedProductIndex, selectedProducts, selectedCollaborators]);

    useImperativeHandle(ref, () => ({
        handleCollaboratorsPurchase
    }));

    const handleGetCollaborators = (filter: CollaboratorRequest) => {

        if(purchaseOption === 3)
            dispatch(getCollaborators(currentUser.token.assignorGuid, currentUser.token.userReferenceId, limit, currentPage, filter));

        if(purchaseOption === 4 && purchaseType !== 1)
            dispatch(getCollaborators(currentUser.token.assignorGuid, currentUser.token.userReferenceId, limit, currentPage, filter));

        if(purchaseOption === 4 && purchaseType === 1)
            dispatch(getCollaborators(currentUser.token.assignorGuid, currentUser.token.userReferenceId, limit, currentPage, filter, groupId));
    };

    const handleSelectCard = (productId: number, index: any) => {
        setSelectedProduct(productId);
        setSelectedProductIndex(index);

        currentPage = 1;

        const collaboratorsFilter = handleCollaboratorsFilter(false);

        if(purchaseOption === 3)
            dispatch(getCollaborators(currentUser.token.assignorGuid, currentUser.token.userReferenceId, limit, 1, collaboratorsFilter))

    }


    const onSelectChange = (newSelectedRowKeys: Key[], selectedRows) => {

        // You can set state or dispatch with something like Redux so we can use the retrieved data
        const updatedSelectedCollaborators = [...selectedCollaborators];
        const collaboratorIndex = updatedSelectedCollaborators.findIndex(x => x.collaboratorId === selectedCollaborators.find(y => !newSelectedRowKeys.includes(y.collaboratorId) && y.productsId.includes(selectedProduct))?.collaboratorId);

        //console.log(newSelectedRowKeys, selectedRows);

        if(collaboratorIndex >= 0 && newSelectedRowKeys.length > 0){

            if(purchaseOption == 3){
                if(updatedSelectedCollaborators[collaboratorIndex].productsId.length > 1){
                    updatedSelectedCollaborators[collaboratorIndex].productsId = updatedSelectedCollaborators[collaboratorIndex].productsId.filter(x=> x != selectedProduct);
                }
                else{
                    updatedSelectedCollaborators.splice(collaboratorIndex, 1);
                }
            }else{
                updatedSelectedCollaborators.splice(collaboratorIndex,1);
            }


            setUpdateSelectedCollaborators(updatedSelectedCollaborators, () =>{
                setSelectedCollaborators(updatedSelectedCollaborators)
            });
        }


        if(purchaseOption == 3){
            let collaboratorProducts: CollaboratorProducts[] = [...selectedCollaborators]
            selectedRows.forEach(element => {
                const isSelected = selectedCollaborators.find(x=>x.collaboratorId == element.collaboratorId)
                if(isSelected){
                    if(!isSelected.productsId.includes(selectedProduct)){
                        isSelected.productsId.push(selectedProduct);
                    }

                    setSelectedCollaborators(updatedSelectedCollaborators);
                }
                if(!isSelected) {
                    const collaboratorProduct: CollaboratorProducts = {
                        collaboratorId: element.collaboratorId,
                        productsId: [selectedProduct]
                    }
                    collaboratorProducts.push(collaboratorProduct)
                }
            });
            setSelectedCollaborators(collaboratorProducts);
        }

        if(purchaseOption == 4){
            let collaboratorProducts: CollaboratorProducts[] = []
            selectedRows.forEach(element => {
                element.isSelected = true;
                element.products = [];
                selectedProducts.forEach(e => {
                    element.products.push(e.productId);
                });

                const collaboratorProduct: CollaboratorProducts = {
                    collaboratorId: element.collaboratorId,
                    productsId: element.products
                }

                collaboratorProducts.push(collaboratorProduct)
            });
            setSelectedCollaborators(collaboratorProducts);
        }
    };

    // const handleSelectAll = (selected, selectedRows, changeRows: any) => {
    //     console.log(selected, selectedRows, changeRows);

    //     const updatedSelectedCollaborators = [...selectedCollaborators];
    //     const collaboratorIndex = updatedSelectedCollaborators.findIndex(x => x.collaboratorId === selectedCollaborators.find(y => !changeRows.includes(y.collaboratorId) && y.productsId.includes(selectedProduct))?.collaboratorId);

    //     // console.log(updatedSelectedCollaborators.filter(x=> changeRows.find(y=> y.collaboratorId === x.collaboratorId)))
    //     // console.log(updatedSelectedCollaborators.filter(x=> !changeRows.includes(x.collaboratorId)))

    //     console.log(
    //         updatedSelectedCollaborators.filter(x=> !changeRows.includes(x.collaboratorId)).map((item: any) => item.collaboratorId)
    //     )

    //     if(changeRows.length <= 0){
    //         setUpdateSelectedCollaborators([], () =>{
    //             setSelectedCollaborators([])
    //         });

    //     }
    // }    

    const handleCollaboratorsFilter = (
        initial: boolean,
        name?: string,
        document?: string,
        register?: string,
        costCenter?: string,
        departament?: string,
        unity?: string, ) => {
        const collaboratorsFilter: CollaboratorRequest = {
            name,
            document,
            register,
            costCenter,
            departament,
            unity,
            products: []
        }

        if(purchaseOption === 3)
            collaboratorsFilter.products = initial ? [productsId[0]] : [selectedProduct];
        if(purchaseOption === 4 && purchaseType !== 1)
            collaboratorsFilter.products = productsId;
        if(purchaseOption === 4 && purchaseType === 1)
            collaboratorsFilter.products = productsOfGroup;

        return collaboratorsFilter;
        
    }

    const handleCollaboratorsPurchase = (): any => {
        if(selectedCollaborators.findIndex(x => x.productsId.length === productsId.length) < 0 && !groupId){
            setErrorMessage("Selecione ao menos um colaborador em cada produto!");
            return true;
        }

        setErrorMessage(null);

        const collaboratorsPurchaseRequest: CollaboratorsPurchaseRequest = {
            purchaseId: purchase,
            collaboratorsProducts: selectedCollaborators
        }

        dispatch(addCollaboratorsPurchase(currentUser.token.assignorGuid, currentUser.token.userReferenceId, collaboratorsPurchaseRequest));
        return false;
    }

    const handleTableChange = (pagination:any) => {

        currentPage = pagination.current;
        limit = pagination.pageSize;

        const collaboratorsFilter = handleCollaboratorsFilter(false);
        
        handleGetCollaborators(collaboratorsFilter);
    };

    const handleFilterModal = (collaboratorFilter: CollaboratorRequest) => {
        const filter = handleCollaboratorsFilter(
            false,
            collaboratorFilter.name,
            collaboratorFilter.document,
            collaboratorFilter.register,
            collaboratorFilter.costCenter,
            collaboratorFilter.departament,
            collaboratorFilter.unity
        )

        currentPage = 1;
        
        handleGetCollaborators(filter);

        dispatch({type: MODAL_COLLABORATORS_PURCHASE_FILTER_HIDE});
    }

    const handleApplyCleanFilter = () => {
        if(isFilterEnabled){
            const filters = handleCollaboratorsFilter(false);
            handleGetCollaborators(filters);
            setIsFilterEnabled(false);
        }
        if(!isFilterEnabled){
            dispatch({type: MODAL_COLLABORATORS_PURCHASE_FILTER_SHOW});
            setIsFilterEnabled(true);
        }
    }

    return (
        <>
            <Box className="p-3">
                <Stack
                key="productsStack"
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={2}
                >
                    {selectedProducts.map((product: Product, index: any) => {
                        if(index === selectedProductIndex && purchaseOption === 3) {
                            return (
                                <Card sx={{ maxWidth: 260 }} key={index}>
                                    <SvgCard
                                        color={product?.productColor}
                                        icon={product?.productIcon}
                                        label={product?.productDescription}
                                    ></SvgCard>
                                </Card>
                            )
                        }

                        return (
                            <Card sx={{ maxWidth: 200 }} key={index}>
                                <CardActionArea onClick={() => handleSelectCard(product?.productId, index)}>
                                    <SvgCard
                                        color={product?.productColor}
                                        icon={product?.productIcon}
                                        label={product?.productDescription}
                                    ></SvgCard>
                                </CardActionArea>
                            </Card>
                        )
                    })}
                </Stack>
                { errorMessage &&
                    <Alert sx={{width: '100%'}} className='my-2' severity="warning">{errorMessage}</Alert>
                }
                <Box>
                    <Grid spacing={2} className='my-2'>
                        <Button
                            variant="contained"
                            onClick={handleApplyCleanFilter}
                        >
                            Aplicar Filtro
                        </Button>
                        { isFilterEnabled &&
                            <Button
                                variant="outlined"
                                className='ml-2'
                                onClick={handleApplyCleanFilter}                                
                            >
                                Remover Filtro
                            </Button>
                        }
                    </Grid>
                </Box>
                <div className="mt-5">
                    <Table
                        dataSource={collaborators.items}
                        loading={loading}
                        rowKey="collaboratorId"
                        pagination={{
                            position: ["bottomRight"],
                            current: currentPage,
                            defaultPageSize: limit,
                            total: collaborators?.totalItems,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '25', '50', '100'],
                            locale: { items_per_page: "" },
                        }}
                        onChange={handleTableChange}
                        rowSelection={{
                            preserveSelectedRowKeys: true,
                            selectedRowKeys: selectedCollaborators?.filter((item: any) => item.productsId?.includes(selectedProduct)).map(item => item.collaboratorId),
                            onChange: onSelectChange,
                        // onSelectAll: handleSelectAll
                        }}
                        >
                        <Column
                            title="Nome"
                            dataIndex="name"
                            key="name"
                        />
                        <Column
                            title="CPF"
                            dataIndex="document"
                            key="document"
                        />
                        <Column
                            title="Matrícula"
                            dataIndex="register"
                            key="register"
                        />
                        <Column
                            title="Centro de Custo"
                            dataIndex="costCenter"
                            key="costCenter"
                        />
                        <Column
                            title="Departamento"
                            dataIndex="departament"
                            key="departament"
                        />
                        <Column
                            title="Unidade"
                            dataIndex="unity"
                            key="unity"
                        />
                    </Table>
                </div>
            </Box>
            
            <CollaboratorsFilterModal 
                isOpen={showCollaboratorsPurchaseFilterModal} 
                onRequestClose={() => dispatch({type: MODAL_COLLABORATORS_PURCHASE_FILTER_HIDE})} 
                onHandleFilter={handleFilterModal} 
            />
        </>
    );
});
